import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import { getCombosHardware } from '~/services-v2/installation-api/installation-api'

export interface EnergyConcessionaire {
  id: number
  name: string
  state: string
  grid_access_approval: boolean
}

/**
 * Energy concessionaires (distributors) used in the Customer Data step.
 * Reuses the same source as the equipment step (installation-api `/hardware/combos`),
 * normalizing the response to the minimal shape the screen needs.
 */
export default function useEnergyConcessionaires(projectId: Ref<string>) {
  return useQuery({
    queryKey: queryKeys.REGISTRATION.ENERGY_CONCESSIONAIRES(projectId),
    queryFn: async (): Promise<EnergyConcessionaire[]> => {
      const combos = await getCombosHardware(projectId.value, null, false)

      return (combos?.distributor ?? []).map(distributor => ({
        id: Number(distributor.id),
        name: distributor.name,
        state: distributor.state ?? '',
        grid_access_approval: distributor.grid_access_approval ?? false,
      }))
    },
    staleTime: 1000 * 60,
    retry: 2,
  })
}

export type UseEnergyConcessionaires = ReturnType<typeof useEnergyConcessionaires>
export type UseEnergyConcessionairesData = UseEnergyConcessionaires['data']['value']
